// extracted by mini-css-extract-plugin
export var discountsDropdown = "discounts-dropdown-module--discounts-dropdown--8vwA5";
export var dropdownBadge = "discounts-dropdown-module--dropdown-badge--KV6lq";
export var dropdownItem = "discounts-dropdown-module--dropdown-item--1ahk3";
export var dropdownLabel = "discounts-dropdown-module--dropdown-label--yJJNN";